import { IssueSupplier } from '@arpada/arp-lib-common-qupro';
import { IssueStateGroupFront, OperatorFront, IssuePriorityFront } from './api.dto';

export class IssueFront extends IssueSupplier {
    issueStateGroup: IssueStateGroupFront;
    operatorFront: OperatorFront;
    issuePriority: IssuePriorityFront;
}
